export default __webpack_public_path__ + "static/media/profile_background.603b5133.png";